/* eslint-disable no-unused-vars */
// saga 사용예정
import 'custom-event-polyfill/polyfill'
import React from 'react'
import ReactDOM from 'react-dom'
import { createStore, compose, applyMiddleware } from 'redux'
import createSagaMiddleware from 'redux-saga'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import App from './component/App'
import Simple from './component/simple'
import Reducer from './libs/reducer'
// import rootSaga from './sagas'

const sagaMiddleware = createSagaMiddleware()
const middlewares = [sagaMiddleware]

const enhancer = process.env.NODE_ENV === 'production'
    ? compose()
    : compose(
        // applyMiddleware(...middlewares),
        typeof window.__REDUX_DEVTOOLS_EXTENSION__ !== 'undefined'
            ? window.__REDUX_DEVTOOLS_EXTENSION__()
            : f => f,
    )

const store = createStore(Reducer, enhancer)
// sagaMiddleware.run(rootSaga)
const header_type = window.HEADER_TYPE || ''


ReactDOM.render(
    <Provider store={store}>
        <BrowserRouter>
            {header_type === 'simple' ? <Simple /> : <App />}
        </BrowserRouter>
    </Provider>,
    document.getElementById('header'),
)



// WEBPACK FOOTER //
// ./src/header/index.js